import React, { useContext } from "react";
import PropTypes from "prop-types";
import { AppContext } from "~context/AppContext";

const Layout = ({ children, className }) => {
  const { notificationActive } = useContext(AppContext);

  //

  return (
    <>
      <main
        id="layout"
        className={`layout ${className} ${
          notificationActive ? `notification-active` : ``
        }`}
      >
        {children}
      </main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};

export default Layout;
